import * as types from "../constants/ActionTypes";
import { store } from "../../redux/store/store";
export const globalStore = store;

//Actions
export function pageChange(response: any) 
{
    return {
        type: types.CHANGE_PAGE,
        payload: response
    };
}

export function userChange(response: any)
{
    return {
        type: types.CHANGE_USER,
        payload: response
    };
}

export function settingsChange(response: any) 
{
    return {
        type: types.CHANGE_PRIVACY_SETTINGS,
        payload: response
    };
}

export function settingsSet(response: any) 
{
    if (response == null)
        response = {"privacySettings" : []}

    return {
        type: types.SET_PRIVACY_SETTINGS,
        payload: response.privacySettings
    };
}

//Dispatches
export function changePage(page: string) 
{
    return (dispatch: any) => 
    {
        dispatch(pageChange(page));
    };
}

export function changeUser(user: User) 
{
    return (dispatch: any) => 
    {
        dispatch(userChange(user));
    };
}

export function setSettings(settings: PrivacySettings) 
{
    return (dispatch: any) => 
    {
        dispatch(settingsSet(settings));
    };
}

export function changeSettings(setting: PrivacySetting) 
{
    return (dispatch: any) => 
    {
        const currentPrivacySettings = globalStore.getState().app.privacySettings;
        const newList = currentPrivacySettings.map((itm: PrivacySetting) =>
        {
            if (itm.settingId === setting.settingId)
            {
                return { ...itm, isActive: setting.isActive };
            }
            return { ...itm };
        });

        dispatch(settingsChange(newList));
    };
}